import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		return <div style={{}}>
		
		<img src={require('./img/googleLogo.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				height:32,
				width:"auto",
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
				fontSize:16,
			}}>
				<span style={{
					fontWeight:"bold"	
				}}>Welcome</span>
				<br/>
				<br/>
				<img src={require("./img/name.png")} style={{
					width:15,
					marginTop:10	
				}}/>
				<span style={{
					marginLeft:15,
					// color:"white"
					// fontWeight:"bold"	
					fontSize:16
				}}>example@gmail.com</span>
				<br/>
				<br/>
				<span style={{
					// color:"white"
					// fontWeight:"bold"	
					fontSize:14
				}}>By continuing, you agree to the <br/><span style={{
					color:global.blue
				}}>Terms of Service</span> and have read the <span style={{
					color:global.blue
				}}>Privacy Policy.</span></span>
				{/* <div style={{
					position:"absolute",					
					top: 152,
					width:230,
					height:48,
					// backgroundColor:global.blue,	
				}} onClick={global.nextStage}>
					<span style={{
						color:global.blue,
						fontSize:14,
						cursor:"pointer"
					}}>Don't sign in</span>
				</div> */}
			</div>
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/Google_agree.js